"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/tag/v1/admin_common.proto (package spwn.tag.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTag = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.tag.v1.AdminTag
 */
class AdminTag extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * tagID(uuid)
         *
         * @generated from field: string tag_id = 1;
         */
        this.tagId = "";
        /**
         * タグ名
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * タグカテゴリ
         *
         * @generated from field: string tag_category = 5;
         */
        this.tagCategory = "";
        /**
         * 表示種別
         *
         * @generated from field: string tag_display_type = 6;
         */
        this.tagDisplayType = "";
        /**
         * 作成日時 (unix timestamp)
         *
         * @generated from field: int64 created_at = 8;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * 更新日時 (unix timestamp)
         *
         * @generated from field: int64 updated_at = 9;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTag().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTag().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTag().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTag, a, b);
    }
}
exports.AdminTag = AdminTag;
AdminTag.runtime = protobuf_1.proto3;
AdminTag.typeName = "spwn.tag.v1.AdminTag";
AdminTag.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kana_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "english_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "tag_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tag_display_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
//# sourceMappingURL=admin_common_pb.js.map